export const portfolioData = {
  // Personal Information
  personal: {
    name: "Mokhles Lajimi",
    title: "Full Stack Mobile & Web Developer",
    description:
      "Full Stack Mobile Developer with 5+ years of experience building high-performance Flutter apps and scalable backends. I focus on smooth UX, reliable data flows, and production-ready delivery across Android, iOS, and the web.",
    email: "mokhleslajimi@gmail.com",
    phone: "+21629060392",
    whatsapp: "https://wa.me/21629060392",
    linkedin: "https://www.linkedin.com/in/mokhleslajimi/",
    github: "https://github.com/mokhleslajimi",
    cv: {
      english: "https://drive.google.com/file/d/1MpKSCuwcWcEIcDAN4X_JzaD5On7_pkOS/view?usp=sharing",
      french: "https://drive.google.com/file/d/1nS1vS7VaBkKpFB7HgVsZlPtojmsTJxr2/view?usp=sharing"
    },
    portfolio: "https://bit.ly/lajimiportfolio",
    location: "Tunisia"
  },

  // About Section
  about: {
    title: "About Me",
    description1: "I'm a passionate developer with 5+ years of experience creating digital solutions that make a difference. I specialize in Flutter mobile development and love turning complex problems into simple, beautiful designs.",
    description2: "When I'm not coding, you can find me exploring new technologies, contributing to open source projects, or sharing my knowledge with the developer community. I'm always eager to learn and grow in this ever-evolving field.",
    stats: [
      { number: "18+", label: "Projects Completed" },
      { number: "5+", label: "Years Experience" },
      { number: "100%", label: "Client Satisfaction" }
    ]
  },

  // Skills Section
  skills: {
    title: "Technical Skills",
    subtitle: "What I build with",
    categories: [
      {
        category: "Mobile Development",
        icon: "📱",
        description: "Cross-platform mobile solutions",
        skills: [
          { name: "Flutter", level: 92, color: "#02569B" },
          { name: "Dart", level: 88, color: "#0175C2" },
          { name: "Kotlin", level: 72, color: "#7F52FF" },
          { name: "Swift", level: 68, color: "#FA7343" },
          { name: "Android", level: 82, color: "#3DDC84" },
          { name: "iOS", level: 78, color: "#000000" }
        ]
      },
      {
        category: "Frontend Development",
        icon: "💻",
        description: "Modern web interfaces",
        skills: [
          { name: "React.js", level: 88, color: "#61DAFB" },
          { name: "TypeScript", level: 82, color: "#3178C6" },
          { name: "Next.js", level: 75, color: "#000000" },
          { name: "Tailwind CSS", level: 85, color: "#06B6D4" },
          { name: "HTML5", level: 90, color: "#E34F26" },
          { name: "CSS3", level: 88, color: "#1572B6" }
        ]
      },
      {
        category: "Backend Development",
        icon: "🔧",
        description: "Robust server solutions",
        skills: [
          { name: "Node.js", level: 85, color: "#339933" },
          { name: "Express", level: 82, color: "#000000" },
          { name: "Python", level: 80, color: "#3776AB" },
          { name: "Flask", level: 75, color: "#000000" },
          { name: "REST APIs", level: 88, color: "#FF6B6B" },
          { name: "GraphQL", level: 70, color: "#E10098" },
          { name: "WebSockets", level: 78, color: "#010101" }
        ]
      },
      {
        category: "Data & Cloud",
        icon: "☁️",
        description: "Scalable data solutions",
        skills: [
          { name: "MongoDB", level: 82, color: "#47A248" },
          { name: "PostgreSQL", level: 78, color: "#336791" },
          { name: "Firebase", level: 85, color: "#FFCA28" },
          { name: "Retool", level: 70, color: "#FF6B35" },
          { name: "CI/CD", level: 72, color: "#2088FF" },
          { name: "Docker", level: 68, color: "#2496ED" },
          { name: "Git", level: 90, color: "#F05032" }
        ]
      }
    ],
    additionalSkills: [
      "Agile/Scrum", "UI/UX Design", "API Testing", "Performance Optimization",
      "State Management", "Responsive Design", "Version Control", "Code Review",
      "Testing & QA", "Project Management", "Client Communication", "Technical Writing"
    ]
  },

  // Projects Section
  projects: {
    title: "Projects",
    subtitle: "Shipped to Play Store, App Store & web",
    categories: [
      { id: "all", name: "All Projects", icon: "fas fa-th" },
      { id: "mobile", name: "Mobile Apps", icon: "fas fa-mobile-alt" },
      { id: "web", name: "Web Apps", icon: "fas fa-globe" },
      { id: "game", name: "Games", icon: "fas fa-gamepad" }
    ],
    items: [
      {
        title: "Travaux IA",
        description: "AI-powered quotes and invoicing for construction contractors. Create itemized quotes from text or voice, manage documents, track revenue, and run the full commercial workflow — with offline draft support and auto-sync.",
        icon: "🏗️",
        category: "mobile",
        status: "Live",
        users: "1+",
        rating: "New",
        tech: ["Flutter", "Dart", "GetX", "go_router", "Dio", "REST API", "Google Sign-In", "Sign in with Apple"],
        features: ["AI Quote Generation", "Quote Editor & PDF Export", "Offline Draft Support", "Finance Dashboard", "Documents Hub", "Client Management", "Planning & Teams", "In-app AI Assistant", "Multi-language (FR/EN/AR)"],
        links: [
          {
            text: "Play Store",
            url: "https://play.google.com/store/apps/details?id=com.nexbuild.traveauai",
            icon: "fab fa-google-play",
            type: "primary"
          },
          {
            text: "App Store",
            url: "https://apps.apple.com/us/app/travaux-ia/id6779563040",
            icon: "fab fa-app-store-ios",
            type: "primary"
          }
        ]
      },
      {
        title: "Click Services",
        description: "Multilingual services marketplace (15+ languages): real-time chat, bookings, wallet & cashback, secure payments.",
        icon: "🛎️",
        category: "mobile",
        status: "Live",
        users: "10K+",
        rating: "4.8",
        tech: ["Flutter", "Node.js", "MongoDB", "Stripe", "PayPal", "Socket.IO", "OneSignal"],
        features: ["Real-time Chat", "Multi-language", "Secure Payments", "Wallet System"],
        links: [
          {
            text: "Play Store",
            url: "https://play.google.com/store/apps/details?id=com.ngtech.cliickservice",
            icon: "fab fa-google-play",
            type: "primary"
          },
          {
            text: "App Store",
            url: "https://apps.apple.com/us/app/click-services/id6744241291",
            icon: "fab fa-app-store-ios",
            type: "primary"
          }
        ]
      },
      {
        title: "CRM MADS",
        description: "Mobile CRM for attic insulation companies in Spain: sales teams register customers and schedule visits, installers manage projects, capture photos, and collect signatures. Offline-first with auto-sync.",
        icon: "🏢",
        category: "mobile",
        status: "Live",
        users: "TBD",
        rating: "TBD",
        tech: ["Flutter", "GetX", "Firebase", "Cloud Firestore", "Node.js", "JWT Authentication", "OneSignal"],
        features: ["Complete Workflow Management", "Customer Registration", "Photo Documentation", "Digital Signatures", "Offline Support"],
        links: [
          {
            text: "Play Store",
            url: "https://play.google.com/store/apps/details?id=com.mads.crm.crm_mads",
            icon: "fab fa-google-play",
            type: "primary"
          },
          {
            text: "App Store",
            url: "https://apps.apple.com/us/app/crm-mads/id6755883908",
            icon: "fab fa-app-store-ios",
            type: "primary"
          }
        ]
      },
      {
        title: "Ritchess",
        description: "Ride-hailing suite (client, driver, admin): booking, live tracking, reviews, zones, payments, notifications.",
        icon: "🚗",
        category: "mobile",
        status: "Live",
        users: "5K+",
        rating: "4.6",
        tech: ["Flutter", "Node.js", "Socket.IO", "MongoDB", "Provider", "GetX"],
        features: ["Live Tracking", "Multi-role App", "Payment Integration", "Real-time Updates"],
        links: [
          {
            text: "Client App",
            url: "https://play.google.com/store/apps/details?id=com.cinnov.ritchess",
            icon: "fab fa-google-play",
            type: "primary"
          },
          {
            text: "Driver App",
            url: "https://play.google.com/store/apps/details?id=com.convergeinnov.ritchess_chaffeur",
            icon: "fab fa-google-play",
            type: "secondary"
          },
          {
            text: "iOS Client",
            url: "https://apps.apple.com/pl/app/ritchess-booking/id6480453386",
            icon: "fab fa-app-store-ios",
            type: "secondary"
          }
        ]
      },
      {
        title: "SPR01 & leFri9i Club",
        description: "Sports academy & club management: attendance, tests, events, news, parental/child profiles, admin tools.",
        icon: "⚽",
        category: "mobile",
        status: "Live",
        users: "2K+",
        rating: "4.7",
        tech: ["Flutter", "Firebase", "Node.js", "OneSignal"],
        features: ["Attendance Tracking", "Event Management", "Parent Portal", "Admin Dashboard"],
        links: [
          {
            text: "SPR01 App",
            url: "https://play.google.com/store/apps/details?id=com.spr.spr01",
            icon: "fab fa-google-play",
            type: "primary"
          },
          {
            text: "leFri9i App",
            url: "https://play.google.com/store/apps/details?id=com.spr.clubafricain",
            icon: "fab fa-google-play",
            type: "secondary"
          },
          {
            text: "SPR01 iOS",
            url: "https://apps.apple.com/us/app/spr01/id6538732463",
            icon: "fab fa-app-store-ios",
            type: "secondary"
          },
          {
            text: "leFri9i iOS",
            url: "https://apps.apple.com/us/app/lefri9i-football-academy/id6737348785",
            icon: "fab fa-app-store-ios",
            type: "secondary"
          }
        ]
      },
      {
        title: "Converge Immob Website",
        description: "Real-estate web platform with AI estimation, 360° media, advanced property filters, authentication, favorites, visit booking, and premium subscription tiers.",
        icon: "🏠",
        category: "web",
        status: "Live",
        users: "2K+",
        rating: "4.8",
        tech: ["React", "Node.js", "MongoDB", "Stripe", "AI/ML"],
        features: ["AI Estimation", "360° Media", "Advanced Filters", "Premium Features"],
        links: [
          {
            text: "View Website",
            url: "http://convergeimmob.com/",
            icon: "fas fa-external-link-alt",
            type: "primary"
          }
        ]
      },
      {
        title: "KMC Tunisia Website & Admin",
        description: "Corporate single-page website and admin dashboard for a construction materials company, built with modern UI/UX and real-time content management.",
        icon: "🏗️",
        category: "web",
        status: "Live",
        users: "B2B",
        rating: "N/A",
        tech: ["React", "TypeScript", "Tailwind CSS", "Firebase", "Firestore"],
        features: ["Marketing Website", "Admin Dashboard", "Realtime Content Management", "SEO Optimized"],
        links: [
          {
            text: "View Website",
            url: "https://kmc-tunisia.web.app/",
            icon: "fas fa-external-link-alt",
            type: "primary"
          }
        ]
      },
      {
        title: "Converge Immob Mobile App",
        description: "Real-estate mobile app with AI property estimation, 360° virtual tours, advanced filters, authentication, favorites, visit booking, and premium tiers.",
        icon: "🏘️",
        category: "mobile",
        status: "Development",
        users: "Demo",
        rating: "TBD",
        tech: ["Flutter", "Firebase", "Node.js", "MongoDB", "Stripe"],
        features: ["AI Estimation", "360° Media", "Advanced Filters", "Premium Features"],
        links: [
          {
            text: "Play Store",
            url: "https://play.google.com/store/apps/details?id=com.cinnov.immob",
            icon: "fab fa-google-play",
            type: "primary"
          }
        ]
      },
      {
        title: "Sfax Outdoor Sports",
        description: "Ecology & nature sports app: circuits (VTT/Rando), reservations, and map tracking.",
        icon: "🏔️",
        category: "mobile",
        status: "Live",
        users: "1K+",
        rating: "4.5",
        tech: ["Flutter", "Firebase", "Mapbox"],
        features: ["Map Integration", "Circuit Tracking", "Reservation System", "Nature Sports"],
        links: []
      },
      {
        title: "Puzzle Swap Game",
        description: "Family-friendly puzzle swap game. Timer challenges, responsive UI, runs on web & mobile.",
        icon: "🧩",
        category: "game",
        status: "Live",
        users: "500+",
        rating: "4.9",
        tech: ["Flutter", "Firebase Hosting", "Provider"],
        features: ["Timer Challenges", "Responsive UI", "Cross-platform", "Family-friendly"],
        links: [
          {
            text: "Play Online",
            url: "https://puzzlciv.web.app/",
            icon: "fas fa-external-link-alt",
            type: "primary"
          }
        ]
      },
      {
        title: "Portfolio Website",
        description: "Personal responsive portfolio with dark mode, smooth animations, multilingual support, and modern design.",
        icon: "💼",
        category: "web",
        status: "Live",
        users: "1K+",
        rating: "5.0",
        tech: ["React", "CSS3", "JavaScript", "Responsive Design"],
        features: ["Responsive Design", "Dark Mode", "Animations", "Performance Optimized"],
        links: [
          {
            text: "View Site",
            url: "https://mokhleslajimiportfolio.netlify.app",
            icon: "fas fa-external-link-alt",
            type: "primary"
          }
        ]
      },
      {
        title: "Chat Application",
        description: "Real-time messaging app with group chats, file sharing, voice messages, and end-to-end encryption.",
        icon: "💬",
        category: "web",
        status: "Live",
        users: "5K+",
        rating: "4.9",
        tech: ["React", "Node.js", "Socket.IO", "MongoDB", "WebRTC"],
        features: ["Real-time Messaging", "File Sharing", "Voice Messages", "Group Chats"],
        links: [
          {
            text: "Try Demo",
            url: "#",
            icon: "fas fa-external-link-alt",
            type: "primary"
          }
        ]
      },
      {
        title: "Sfax Tour Visually Impaired",
        description: "Mobile application that promotes the heritage of Sfax city, allowing visually impaired people to discover treasures by answering questions at different locations using audio instructions.",
        icon: "👁️",
        category: "mobile",
        status: "Live",
        users: "500+",
        rating: "4.8",
        tech: ["Flutter", "Firestore", "Authentication", "RealTime", "MVC"],
        features: ["Audio Instructions", "Heritage Discovery", "Accessibility", "Location-based Questions"],
        links: []
      },
      {
        title: "BTT Transfer",
        description: "Streamlined transportation experience with Flutter Firebase. Admins create and manage excursions, assign drivers, while clients request to join courses, access history, and manage accounts.",
        icon: "🚌",
        category: "mobile",
        status: "Live",
        users: "1K+",
        rating: "4.6",
        tech: ["Flutter", "Firebase", "Ibeacon", "State Management"],
        features: ["Excursion Management", "Driver Assignment", "Client Requests", "Account Management"],
        links: [
          {
            text: "Play Store",
            url: "#",
            icon: "fab fa-google-play",
            type: "primary"
          }
        ]
      },
      {
        title: "Djerba Eye Land",
        description: "Application that helps discover the geographical space bringing together French speakers worldwide, featuring 88 states and governments with interactive exploration features.",
        icon: "🌍",
        category: "mobile",
        status: "Live",
        users: "800+",
        rating: "4.7",
        tech: ["Flutter", "Firebase", "Maps", "Localization"],
        features: ["Geographical Discovery", "French-speaking Countries", "Interactive Maps", "Cultural Information"],
        links: [
          {
            text: "Play Store",
            url: "#",
            icon: "fab fa-google-play",
            type: "primary"
          }
        ]
      },
      {
        title: "Quiz كتاب",
        description: "Educational quiz application with unique QR codes for scanning questions, covering diverse subjects for all ages with engaging and user-friendly interface.",
        icon: "📚",
        category: "mobile",
        status: "Live",
        users: "2K+",
        rating: "4.9",
        tech: ["Flutter", "Provider", "Firebase", "Animation"],
        features: ["QR Code Scanning", "Diverse Subjects", "All Ages", "User Accounts"],
        links: []
      },
      {
        title: "Carrot",
        description: "Social application with timeline, profile management, notifications, and admin features for user management and point system between users.",
        icon: "🥕",
        category: "mobile",
        status: "Live",
        users: "1.5K+",
        rating: "4.5",
        tech: ["Flutter", "GetX", "Provider", "Flask", "SQLite", "Python"],
        features: ["Timeline", "Profile Management", "Point System", "Admin Panel"],
        links: [
          {
            text: "Play Store",
            url: "#",
            icon: "fab fa-google-play",
            type: "primary"
          }
        ]
      },
      {
        title: "Shopping Fest",
        description: "Mobile entertainment application for raffle games and winning countless gifts. Users can participate in various games and win prizes.",
        icon: "🎁",
        category: "mobile",
        status: "Live",
        users: "3K+",
        rating: "4.6",
        tech: ["Flutter", "GetX", "Provider", "Firebase", "QR Scanner"],
        features: ["Raffle Games", "Prize System", "QR Code Scanner", "Entertainment"],
        links: [
          {
            text: "Play Store",
            url: "#",
            icon: "fab fa-google-play",
            type: "primary"
          }
        ]
      },
      {
        title: "Djerba Discovery",
        description: "Tourist and historical places discovery app for Djerba with iBeacon technology for visually impaired users. Features include AR markers, map routing, and panoramic photos.",
        icon: "🏛️",
        category: "mobile",
        status: "Live",
        users: "1.2K+",
        rating: "4.8",
        tech: ["Flutter", "Node.js", "GetX", "Provider", "Firebase", "Mapbox", "iBeacon"],
        features: ["Historical Places", "iBeacon Technology", "AR Markers", "Map Routing", "Panoramic Photos"],
        links: [
          {
            text: "Play Store",
            url: "#",
            icon: "fab fa-google-play",
            type: "primary"
          }
        ]
      },
      {
        title: "Hdya - Instagram Clone",
        description: "Instagram clone application with multiple features including social media functionality, photo sharing, and Gmail authentication.",
        icon: "📸",
        category: "mobile",
        status: "Live",
        users: "2.5K+",
        rating: "4.7",
        tech: ["Flutter", "Provider", "Firestore", "Authentication"],
        features: ["Photo Sharing", "Social Feed", "Gmail Login", "User Profiles"],
        links: [
          {
            text: "Play Store",
            url: "#",
            icon: "fab fa-google-play",
            type: "primary"
          }
        ]
      }
    ]
  },

  // Experience Section
  experience: {
    title: "Experience",
    subtitle: "Growth, ownership, and impact across mobile & web",
    items: [
      {
        period: "09/2025 - Present",
        title: "Mobile Flutter Developer",
        company: "NexBuild, Tunisie",
        description:
          "Led cross-platform mobile app development with Flutter, implementing performant and responsive UI/UX from design mocks. Deployed and updated applications on Google Play Store and Apple App Store. Contributed to project planning and technical specifications, and integrated reliable backend APIs for Flutter apps using tools like Postman and Swagger.",
      },
      {
        period: "01/2024 - 09/2025",
        title: "Senior Flutter Developer | Full Stack Web Developer",
        company: "Converge Innova, Tunisie",
        description:
          "Led cross-platform mobile app development using Flutter. Designed and implemented backend architecture with Node.js and MongoDB. Deployed, monitored, and maintained client solutions. Participated in technical planning and specification design. Performed thorough API testing with Postman and Swagger. Collaborated effectively in a Scrum-based Agile team.",
      },
      {
        period: "02/2022 – 01/2024",
        title: "Flutter & Backend Developer",
        company: "3D Wave Sousse, Tunisie",
        description:
          "Developed mobile apps using Flutter across Android and iOS. Collaborated with cross-functional teams in Agile/Scrum settings. Delivered and maintained complete client solutions (mobile + backend). Participated in the design and development of innovative features. Built and integrated backend services using Node.js and Flask (Python).",
      },
      {
        period: "02/2021 – 11/2023",
        title: "Full Stack Developer",
        company: "Lonch (FreeLance)",
        description:
          "Developed interactive dashboards with Retool. Built and maintained reusable Flutter packages. Integrated frontend with backend using JavaScript and GraphQL. Managed tasks and workflow via Notion.",
      }
    ]
  },

  // Contact Section
  contact: {
    title: "Let's talk",
    subtitle: "Have an idea? I'll help you ship it.",
    methods: [
      {
        name: "WhatsApp",
        url: "https://wa.me/21629060392",
        icon: "fab fa-whatsapp"
      },
      {
        name: "Email",
        url: "mailto:mokhleslajimi@gmail.com",
        icon: "fas fa-envelope"
      },
      {
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/mokhleslajimi/",
        icon: "fab fa-linkedin"
      }
    ],
    form: {
      action: "https://formsubmit.co/mokhleslajimi@gmail.com",
      fields: [
        { name: "name", label: "Your name", placeholder: "Jane Doe", required: true },
        { name: "email", label: "Email", placeholder: "jane@example.com", required: true },
        { name: "company", label: "Company (optional)", placeholder: "Acme Inc.", required: false },
        { name: "message", label: "Project details", placeholder: "What are you building? Timeline, platforms, key features…", required: true, type: "textarea" }
      ],
      hint: "Reply within 24–48h.",
      submitText: "Send message"
    }
  },

  // Footer
  footer: {
    description: "Full-stack mobile & web developer shipping real products.",
    quickLinks: [
      { name: "Skills", action: "scroll", target: "skills" },
      { name: "Projects", action: "scroll", target: "projects" },
      { name: "Experience", action: "scroll", target: "experience" },
      { name: "Download CV", action: "link", target: "dynamic_cv" }
    ],
    services: [
      "Mobile App Development",
      "Web Development", 
      "Backend Development",
      "UI/UX Consulting",
      "Technical Consulting"
    ],
    socialLinks: [
      { name: "GitHub", url: "https://github.com/mokhleslajimi", icon: "fab fa-github" },
      { name: "LinkedIn", url: "https://www.linkedin.com/in/mokhleslajimi/", icon: "fab fa-linkedin" },
      { name: "WhatsApp", url: "https://wa.me/21629060392", icon: "fab fa-whatsapp" }
    ],
    copyright: "© 2025 Mokhles Lajimi. All rights reserved."
  }
};
